export default __webpack_public_path__ + "static/media/left.f4b7fdc2.png";